import React from 'react'
import clsx from 'clsx'
import { Box } from '@material-ui/core'
import { CircledText } from '~/components/'
import { mutualTheme } from '~/utils/theme'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
  responsiveSteps: {
    height: 50,
    width: '100vw',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: mutualTheme.spacing(1),
    backgroundColor: mutualTheme.palette.common.white
  },
  stepSeparator: {
    width: 8,
    height: 2,
    marginLeft: mutualTheme.spacing(0.5),
    marginRight: mutualTheme.spacing(0.5),
    backgroundColor: mutualTheme.palette.grey[400]
  },
  activedSeparator: {
    backgroundColor: mutualTheme.palette.blue.main
  }
})

const Separator = () => {
  const classes = useStyles()

  return <Box className={clsx(classes.stepSeparator, classes.activedSeparator)} />
}

export const ResponsiveStepIndicator: React.FC = () => {
  const classes = useStyles()

  return (
    <Box className={classes.responsiveSteps}>
      <CircledText
        circleText='1'
        finished
      />
      <Separator />
      <CircledText
        circleText='2'
        finished
      />
      <Separator />
      <CircledText
        circleText='3'
        finished
      />
      <Separator />
      <CircledText
        circleText='4'
        finished
      />
      <Separator />
      <CircledText
        circleText='5'
        finished
      />
    </Box>
  )
}
